// Shared colours without customer theme tokens.
export const DRAG_HANDLE = '#6F7684'
export const MUTED_TEXT = '#8A8A8A'
export const SUCCESS = 'rgba(16, 208, 112, 1)'
export const SUCCESS_LIGHT = 'rgba(16, 208, 112, 0.1)'
export const DISABLED_CONTROL_BORDER = '#E0E0E0'
export const DISABLED_CONTROL_ICON = '#BDBDBD'

export const MUTED_TEXT_DARK = '#6b6b6b'
export const MUTED_TEXT_MID = '#767676'
export const SECONDARY_TEXT = '#555555'
export const PLACEHOLDER_ICON = '#9a9a9a'
export const MUTED_ICON = '#b5b5b5'
export const PANEL_BORDER = '#dcdcdc'
export const HAIRLINE = '#ececec'
export const PILL_BORDER = '#c9c9c9'
export const THUMB_BORDER = '#d0d0d0'
export const PAPER = '#ffffff'
export const PAGE_SHADOW = '0 1px 4px rgba(0, 0, 0, 0.18)'
export const SUBTLE_FILL = 'rgba(0, 0, 0, 0.06)'
export const POPOVER_SHADOW = '0 10px 30px rgba(0, 0, 0, 0.16), 0 2px 8px rgba(0, 0, 0, 0.08)'
export const NOTICE_WARNING_BG = '#fdf3e7'
export const NOTICE_WARNING_TEXT = '#6b4e1d'
export const NOTICE_WARNING_ICON = '#e7a54b'
export const ERROR_TEXT_DARK = '#7a2d25'
export const HIGHLIGHT_BG = 'rgba(255, 214, 10, 0.35)'
export const AI_BOX_FILL = 'rgba(0, 0, 0, 0.22)'
export const AI_BOX_STROKE = '#555555'

// Apply opacity to supported theme colour formats.
export function withAlpha(color, alpha) {
  const rgba = String(color).match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i)
  if (rgba) return `rgba(${rgba[1]}, ${rgba[2]}, ${rgba[3]}, ${alpha})`
  const hex = String(color).match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
  if (hex) {
    const h = hex[1].length === 3 ? [...hex[1]].map(c => c + c).join('') : hex[1]
    const [r, g, b] = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16))
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }
  return color
}
